import React, { useState } from 'react';

import UnifiedViewBasics from './UnifiedViewBasics';
import UnifiedEditBasics from './UnifiedEditBasics';

const UnifiedBasics = (props) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      {!isEditing ? (
        <UnifiedViewBasics {...props} setIsEditing={setIsEditing} />
      ) : (
        <UnifiedEditBasics {...props} setIsEditing={setIsEditing} />
      )}
    </>
  );
};

export default UnifiedBasics;
